import {
	trackingByID,
	trackingCreate,
	trackingDestroy,
	trackingList,
	trackingUpdate,
} from '@/services/agency/trackings.service'

export default {
	namespaced: true,
	state: {
		// SERVICE TRACKING
		trackingList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		tracking: {},

		// STATUS SERVICE TRACKING
		trackingStatus: 'pending',
		trackingSaveStatus: 'init',
		trackingDeleteStatus: 'init',
	},
	getters: {
		// SERVICE TRACKING
		getTrackingList(state) {
			return state.trackingList
		},
		getTracking(state) {
			return state.tracking
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE TRACKING
		getTrackingDeleteStatus(state) {
			return state.trackingDeleteStatus
		},
		getTrackingSaveStatus(state) {
			return state.trackingSaveStatus
		},
		getTrackingStatus(state) {
			return state.trackingStatus
		},
	},
	mutations: {
		// SERVICE TRACKING
		TRACKING_LIST(state, value) {
			state.trackingList = value
		},
		SET_TRACKING(state, value) {
			state.tracking = value
		},

		// STATUS SERVICE TRACKING
		TRACKING_STATUS(state, value) {
			state.trackingStatus = value
		},
		TRACKING_SAVE_STATUS(state, value) {
			state.trackingSaveStatus = value
		},
		TRACKING_DELETE_STATUS(state, value) {
			state.trackingDeleteStatus = value
		},
	},
	actions: {
		// Service Tracking
		async fetchTrackingList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('TRACKING_STATUS', 'pending')
			commit('TRACKING_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await trackingList(params)
				commit('TRACKING_STATUS', 'init')
				commit('TRACKING_LIST', data)
				return data
			} catch (error) {
				commit('TRACKING_STATUS', 'init')
				throw error
			}
		},
		async fetchTrackingByID({ commit }, params) {
			commit('TRACKING_STATUS', 'pending')
			try {
				const { data } = await trackingByID(params)
				commit('TRACKING_STATUS', 'init')
				commit('SET_TRACKING', data.data)
				return data
			} catch (error) {
				commit('TRACKING_STATUS', 'init')

				return error
			}
		},
		async saveNewTracking({ commit }, params) {
			commit('TRACKING_SAVE_STATUS', 'pending')
			try {
				const { data } = await trackingCreate(params)
				commit('TRACKING_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TRACKING_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateTracking({ commit }, params) {
			commit('TRACKING_SAVE_STATUS', 'pending')
			try {
				const { data } = await trackingUpdate(params)
				commit('TRACKING_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TRACKING_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteTrackingByID({ commit }, params) {
			commit('TRACKING_DELETE_STATUS', 'pending')
			try {
				const { data } = await trackingDestroy(params)
				commit('TRACKING_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TRACKING_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
